export default {
  apartmentStatistics: [
    {
      text: "Arvonnousu",
      formula:
        "[[ (({{Hinta-arvio}} - {{Velaton kauppahinta veroineen}}) / {{Velaton kauppahinta veroineen}}) * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Neliövuokra",
      formula: "[[ {{Vuokratulo / kk}} / {{Pinta-ala}} ]] €/m²",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Bruttovuokratulo / v (€)",
      formula: "[[ {{Vuokratulo / kk}} * 12 ]] €",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Bruttovuokratuotto (%)",
      formula: "[[ ({{Vuokratulo / kk}} * 12) / {{Velaton kauppahinta veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Nettovuokratulo / v (€)",
      formula:
        "[[ ({{Kokonaistulo / kk}}  - {{Hoitovastike}} - {{Vesimaksu}} - {{Yhtiölainojen maksuerät / kk}}) * 12 ]] €",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Sijoitetun pääoman tuotto (ROI)",
      formula:
        "[[ (({{Kokonaistulo / kk}} - {{Hoitovastike}} - {{Vesimaksu}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / {{Velaton kauppahinta veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Oman pääoman tuotto (ROE)",
      formula:
        "[[ (({{Kokonaistulo / kk}} - {{Hoitovastike}} - {{Vesimaksu}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / ({{Velaton kauppahinta veroineen}} - {{Yhtiölainat yhteensä}}) * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Omavaraisuusaste",
      formula: "[[ (1 - ({{Yhtiölainat yhteensä}} / {{Hinta-arvio}})) * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Velkaantuneisuusaste",
      formula: "[[ {{Yhtiölainat yhteensä}} / {{Velaton kauppahinta veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "LTV (Loan-to-Value)",
      formula: "[[ {{Yhtiölainat yhteensä}} / {{Hinta-arvio}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Kassavirta",
      formula:
        "[[ {{Kokonaistulo / kk}} - ({{Hoitovastike}} + {{Vesimaksu}} + {{Yhtiölainojen maksuerät / kk}}) ]] €/kk",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Kriittinen piste",
      formula: "[[ {{Hoitovastike}} + {{Vesimaksu}} + {{Yhtiölainojen maksuerät / kk}} ]] €/kk",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Velan tuotto (Debt Yield)",
      formula:
        "[[ (({{Kokonaistulo / kk}} - {{Hoitovastike}} - {{Vesimaksu}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / {{Yhtiölainat yhteensä}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
  ],

  cityStatistics: [
    {
      text: "Arvonnousu",
      formula:
        "[[ (({{Hinta-arviot}} - {{Velattomat kauppahinnat veroineen}}) / {{Velattomat kauppahinnat veroineen}}) * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Neliövuokra (€ / m²)",
      formula: "[[ {{Vuokratulot (toistuvat) / kk}} / {{Pinta-ala yht.}} ]] €/m²",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Bruttovuokratuotto (%)",
      formula:
        "[[ ({{Vuokratulot (toistuvat) / kk}} * 12) / {{Velattomat kauppahinnat veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Sijoitetun pääoman tuotto (ROI)",
      formula:
        "[[ (({{Kokonaistulot (toistuvat) / kk}} - {{Hoitovastikkeet}} - {{Vesimaksut}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / {{Velattomat kauppahinnat veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Oman pääoman tuotto (ROE)",
      formula:
        "[[ (({{Kokonaistulot (toistuvat) / kk}} - {{Hoitovastikkeet}} - {{Vesimaksut}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / ({{Velattomat kauppahinnat veroineen}} - {{Yhtiölainat yhteensä}})  * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Omavaraisuusaste",
      formula:
        "[[ (1 - ({{Yhtiölainat yhteensä}} / {{Velattomat kauppahinnat veroineen tai hinta-arviot}})) * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Velkaantuneisuusaste",
      formula: "[[ {{Yhtiölainat yhteensä}} / {{Velattomat kauppahinnat veroineen}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "LTV (Loan-to-Value)",
      formula:
        "[[ {{Yhtiölainat yhteensä}} / {{Velattomat kauppahinnat veroineen tai hinta-arviot}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Kassavirta (€ / kk)",
      formula:
        "[[ {{Kokonaistulot (toistuvat) / kk}} - {{Hoitovastikkeet}} - {{Vesimaksut}} - {{Yhtiölainojen maksuerät / kk}} ]] €",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Kriittinen piste",
      formula: "[[ {{Hoitovastikkeet}} + {{Vesimaksut}} + {{Yhtiölainojen maksuerät / kk}} ]] €/kk",
      rounding: 2,
      formatAsCurrency: true,
    },
    {
      text: "Velan tuotto (Debt Yield)",
      formula:
        "[[ (({{Kokonaistulot (toistuvat) / kk}} - {{Hoitovastikkeet}} - {{Vesimaksut}} - {{Yhtiölainojen maksuerät / kk}}) * 12) / {{Yhtiölainat yhteensä}} * 100 ]] %",
      rounding: 2,
      formatAsCurrency: false,
    },
    {
      text: "Hetkellinen käyttöaste (%)",
      formula:
        "[[ {{Voimassa olevien sopimusten määrä}} / {{Mahdollinen sopimusten määrä}} * 100 ]] %",
      rounding: 1,
      formatAsCurrency: false,
    },
  ],
};
